export default {
  data() {
    return {
      workTypeList: [
        { id: 1, name: '周期工' },
        { id: 2, name: '临时工' },
        { id: 3, name: '长周期工' }
      ],
      workTypeObj: {
        1: '周期工',
        2: '临时工',
        3: '长周期工'
      }
    }
  },
  created() {
  },
  methods: {
  }
}